"use strict";

$(document).ready(function () {
  if ($(".haze-container").length > 0) {
    var fixmeTop = $(".haze-container").offset().top; // get initial position of the element

    $(window).scroll(function () {
      // assign scroll event listener

      var currentScroll = $(window).scrollTop(); // get current position

      if (currentScroll + 56 >= fixmeTop) {
        // apply position: fixed if you
        $(".haze-container").addClass("fixed-bar");
      } else {
        // apply position: static
        $(".haze-container").removeClass("fixed-bar");
      }
    });
  }
});